import styles from "./index.module.scss";
import TableHeaders from "./table-headers";
import TableRow from "./table-row";
import { IMemberData } from "../../../../common/validations/members-access.validations";
import cn from "../../../../Utils/class-names.utils";
import { FormikErrors, FormikTouched } from "formik";

interface MembersTableProps {
  membersData: IMemberData[];
  onAddRole: (userEmail: string, roleToAdd: string) => void;
  onRemoveRole: (userEmail: string, roleToRemove: string) => void;
  onResetPasswordClick: () => void;
  isDistributorView?: boolean;
}

const MembersTable = ({ 
  membersData, 
  onAddRole, 
  onRemoveRole,
  onResetPasswordClick,
  isDistributorView = false,
}: MembersTableProps) => {
  return (
    <div className={cn(styles.table, "table-wrapper hide-scrollbar")}>
      <TableHeaders />
      {membersData.map((userData, index) => {
        return (
          <TableRow
            key={`${userData.email}-${index}`}
            userData={userData}
            onAddRole={onAddRole}
            onRemoveRole={onRemoveRole}
            onResetPasswordClick={onResetPasswordClick}
            isDistributorView={isDistributorView}
          />
        );
      })}
    </div>
  );
};

export default MembersTable;
